module.exports = __webpack_public_path__ + "img/landing2.6c3cb5d8.svg";